//https://www.youtube.com/watch?v=u3KlatzB7GM
import {createSlice} from "@reduxjs/toolkit";

//  this showed how to create the reducer
// https://stackoverflow.com/questions/68971771/react-redux-toolkit-action-in-dispatch-returns-err-object-is-not-a-functi

// const initialState = {value: {id: 0, mcode: "", name:"", description: ""}};

export const obligationHierarchySlice = createSlice({
    name: 'obligationHiearchySlc',
    initialState: {value: {myCdpId: null, cdpvId: 0, externalSource: null, displayValue: null, dataPointName: null, contractName: null,
            reuseMarket: null, dataType: null,
            financialGridOpen: false, usageGridOpen: false,
            licenseGridOpen: false, platformGridOpen: false,
            subscriberGridOpen: false,viewershipGridOpen: false,
            productGridOpen: false,            stakeholderListGridOpen: false,
            refreshObligationGrid: false, refreshPaymentGrid: false,        myTitleId: null,
            myProductId: null, myGuildId: null, myR2m: null,
        addOnCdpId: null, addOnHierarchy: null, addOnHierarchyLevel: null, addOnMaxRowId: null
        }},
    reducers:
        // {
        //     changeObligationHierarchy: (state, action) => {
        //         state.value = action.payload;
        //     },
        // }
{
    changeObligationHierarchy: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeObligationHierarchy } = obligationHierarchySlice.actions;

export default  obligationHierarchySlice.reducer ;
